/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import React from "react";

import { STATUS } from "./constants/status";
import {
  aFewLeftStyle,
  baseStyle,
  beforeEventStyle,
  beforeSaleStyle,
  duringEventStyle,
  endStyle,
  eventEndedStyle,
  newStyle,
  onSaleStyle,
  preparingShipmentStyle,
  shippedStyle,
  soldOutStyle,
} from "./styles";
import { useThis } from "./useThis";

import type { FcWithoutChildren } from "../../types/fcWithoutChildren";
import type { Props } from "./props";
import type { DisplayStatus } from "./types/displayStatus";
import type { SerializedStyles } from "@emotion/react";

const BACKGROUND_COLOR_STYLE_MAP: Record<DisplayStatus, SerializedStyles> = {
  aFewLeft: aFewLeftStyle,
  beforeEvent: beforeEventStyle,
  beforeSale: beforeSaleStyle,
  duringEvent: duringEventStyle,
  end: endStyle,
  eventEnded: eventEndedStyle,
  new: newStyle,
  onSale: onSaleStyle,
  preparingShipment: preparingShipmentStyle,
  shipped: shippedStyle,
  soldOut: soldOutStyle,
};

const getApplyStyles = (input: DisplayStatus) => {
  const backgroundColorStyle = BACKGROUND_COLOR_STYLE_MAP[input];

  return css`
    ${baseStyle};
    ${backgroundColorStyle};
  `;
};

export const StatusLabel: FcWithoutChildren<Props> = (props) => {
  const { text } = useThis(props);

  const { status } = props;
  if (status === STATUS.NO_LABEL) {
    return null;
  }

  const applyStyles = getApplyStyles(status);

  return <span css={applyStyles}>{text}</span>;
};
